import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { closeDrawer, confirm, getMapUrl, getURLSegment, promptUser, toHours } from '../../helpers/helpers.js';

// Translations
import translate from '../Translate.js';

// Dependencies
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import moment from 'moment';

// Components
import * as icons from '../Icons/Icons';
import ExamAttachmentsList from '../Modules/ExamAttachmentsList';
import Privacy from '../Common/Privacy';
import FileUpload from '../Modules/FileUpload';

const SessionInformation = observer(class SessionInformation extends React.Component {
  constructor() {
    super();
    this.showPassword = this.showPassword.bind(this);
    this.minimizeSession = this.minimizeSession.bind(this);
    this.closeSession = this.closeSession.bind(this);
    this.closeCompletedSession = this.closeCompletedSession.bind(this);
    this.closeWrittenSession = this.closeWrittenSession.bind(this);
    this.handleTabs = this.handleTabs.bind(this);
    this.getRoster = this.getRoster.bind(this);
    this.getIncidents = this.getIncidents.bind(this);
    this.reportIncident = this.reportIncident.bind(this);
  }

  componentWillMount() {
    const { ManagerStore, SessionStore, ScheduleStore } = this.props.store;
    const { session } = this.props;

    if (ScheduleStore.session !== session) ScheduleStore.session = session;
    this.state = {
      activeTab: 0,
      minimize: this.props.minimize,
      showPassword: false,
      returnFiles: ManagerStore.returnFiles,
      hideUpload: false
    }

    // Get the current time
    SessionStore.getCurrentTime(true);

    // Hide the upload field if the exam has been returned
    if(session.returnedFile && session.returnedFile.file) {
      this.setState({
        hideUpload: true
      });
    }
  }

  componentDidMount() {
    const { location, store, appointmentTimeline } = this.props;
    const { ScheduleStore, SessionStore } = store;
    if(appointmentTimeline){

      let appointment = {};

      const accountSid = SessionStore.userData.proctorAccountSid;

      if (ScheduleStore.events[0] && ScheduleStore.events[0].appointment) {
        appointment = ScheduleStore.events[0].appointment;
        ScheduleStore.listSeats(accountSid, location.sid, appointment.sid, 'title');
        ScheduleStore.getCalendar(location.sid, appointment.calendar.sid);
      }      
    }

  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      minimize: nextProps.minimize
    });
  }

  showPassword() {
    this.setState({
      showPassword: !this.state.showPassword
    });
  }

  minimizeSession(accessKey) {
    this.setState({
      minimize: !this.state.minimize
    });

    let minimized = [...this.props.parent.state.minimized];

    minimized.push(accessKey);

    this.props.parent.setState({
      minimized
    });
  }

  closeSession() {
    this.props.store.ManagerStore.closeExamSession(this.props.session.sid);
  }

  confirmComplete(installSid, examSid, sessionSid) {
    const { translation } = this.props;

    const msg = {
      heading: translation.complete_prompt.heading,
      body: translation.complete_prompt.body,
      button: translation.complete_prompt.button
    }

    confirm(msg, () => this.completeSession(installSid, examSid, sessionSid));
  }

  completeSession(installSid, examSid, sessionSid) {
    const { session } = this.props;
    const { ManagerStore } = this.props.store;

    let callback = null;

    if(session.exam.type.toLowerCase() !== 'written') {
      callback = this.closeCompletedSession;
    } else {
      callback = this.closeWrittenSession;
    }

    ManagerStore.completeExamSession(
      installSid,
      examSid,
      sessionSid,
      callback,
      this.props.session.schedulingModule
    );
  }

  closeCompletedSession() {
    const { translation } = this.props;
    const { SessionStore } = this.props.store;

    this.closeSession();

    closeDrawer(null, this.props.parent, getURLSegment(this, 1));

    SessionStore.showToaster(translation.session_closed, 'success');
  }

  closeWrittenSession() {
    const { session, translation } = this.props;
    const { SessionStore } = this.props.store;

    session.status = 'Closed';

    SessionStore.showToaster(translation.session_closed, 'success');
  }

  confirmCancel(sessionSid) {
    const { translation } = this.props;

    const msg = {
      heading: translation.cancel_confirm_prompt.heading,
      body: translation.cancel_confirm_prompt.body,
      button: translation.cancel_confirm_prompt.button
    }

    confirm(msg, () => this.initCancel(sessionSid));
  }

  changeSeat() {
    const { store, translation } = this.props;
    const { ScheduleStore } = store;
    const { locationSeats } = ScheduleStore; // These are the seats for the location
    const appointmentSid = ScheduleStore.events[0].appointment.sid;
    const options = locationSeats.map(seat => {
      return {
        label: seat.title,
        value: seat.sid
      }
    });
    options.push({label: 'Unassigned', value: null});

    const callback = (seatSid) => {
      // Refresh the calendar and update seat name for session
      this.props.refreshEvents();
      const newSeat = ScheduleStore.locationSeats.find(seat => seat.sid === seatSid);
      ScheduleStore.events[0].appointment.seat.title = newSeat.title;
    }

    const msg = {
      heading: translation.seat_prompt.heading,
      body: translation.seat_prompt.body,
      button: translation.seat_prompt.button,
      options,
    }

    promptUser(msg, (value) => ScheduleStore.changeSeat(value, appointmentSid, callback));
  }

  changeStatus() {
    const { store, session, translation } = this.props
    const { ScheduleStore } = store;
    const currentStatus = ScheduleStore.session.status;
    const options = [
      {
        label: 'Checked In',
        value: 'Checked In'
      },
      {
        label: 'In Progress',
        value: 'In Progress'
      },
      {
        label: 'Closed',
        value: 'Closed'
      }
    ];

    const index = options.findIndex(option => option.label === currentStatus);
    if (index !== -1) {
      options.splice(0, index + 1);
    }

    const msg = {
      heading: translation.status_prompt.heading,
      body: translation.status_prompt.body,
      button: translation.status_prompt.button,
      options,
    }


    promptUser(msg, (value) => ScheduleStore.changeSessionStatus(session.installSid, session.exam.sid, session.sid, value), () => this.props.refreshEvents())
  }

  initCancel(sessionSid) {
    const _this = this;
    const { translation } = this.props;

    const options = [
      {
        label: translation.cancel_options.helper,
        value: ''
      }, {
        label: translation.cancel_options.no_show,
        value: 'no-show'
      }, {
        label: translation.cancel_options.changed_time,
        value: 'changed-time'
      }, {
        label: translation.cancel_options.technical_issue,
        value: 'technical-issue'
      }, {
        label: translation.cancel_options.other,
        value: 'other-reason'
      }
    ]

    const msg = {
      heading: translation.cancel_prompt.heading,
      options,
      button: translation.cancel_prompt.button
    }

    const setReason = (memo, selectedReason) => {
      const data = {
        cancellationMemo: memo,
        reason: selectedReason
      }

      _this.cancelSession(sessionSid, data)
    }

    promptUser(msg, setReason, null);
  }

  cancelSession(sessionSid, data) {
    const { translation } = this.props;
    const { ManagerStore, SessionStore } = this.props.store;

    const callback = () => {
      closeDrawer(null, this.props.parent, null);
      SessionStore.showToaster(translation.session_cancelled, 'success');
    }

    ManagerStore.cancelExamSession(sessionSid, data, callback);
  }

  handleTabs(index) {
    this.setState({
      activeTab: index
    })
  }

  permittedItems() {
    const { translation } = this.props;
    const { examConfiguration } = this.props.session;

    const items = [
      {
        item: 'Bathroom Break',
        permitted: examConfiguration.permittedBathroomBreak,
        notes: examConfiguration.permittedBathroomBreakInformation
      }, {
        item: 'Blank Paper',
        permitted: examConfiguration.permittedBlankPaper,
        notes: examConfiguration.permittedBlankPaperInformation
      }, {
        item: 'Calculator',
        permitted: examConfiguration.permittedCalculator,
        notes: examConfiguration.permittedCalculatorInformation
      }, {
        item: 'Dictionary',
        permitted: examConfiguration.permittedDictionary,
        notes: examConfiguration.permittedDictionaryInformation
      }, {
        item: 'Earplugs',
        permitted: examConfiguration.permittedEarplugs,
        notes: examConfiguration.permittedEarplugsInformation
      }, {
        item: 'Formula Sheets',
        permitted: examConfiguration.permittedFormulaSheet,
        notes: examConfiguration.permittedFormulaSheetInformation
      }, {
        item: 'Notes',
        permitted: examConfiguration.permittedNotes,
        notes: examConfiguration.permittedNotesInformation
      }, {
        item: 'Textbook',
        permitted: examConfiguration.permittedTextbook,
        notes: examConfiguration.permittedTextbookInformation
      }, {
        item: 'Websites',
        permitted: examConfiguration.permittedWebsites,
        notes: examConfiguration.permittedWebsitesInformation
      }
    ]

    let permittedItems = [];

    for(let i = 0; i < items.length; i++) {
      if(items[i].permitted) {
        const permittedItem = React.createElement('li', {key: `${i}`},
          React.createElement('strong', null, `${items[i].item}:`),
          React.createElement('p', null, items[i].notes || translation.permitted_items.permitted)
        );
        permittedItems.push(permittedItem);
      }
    }

    if(examConfiguration.permittedOtherItems) {
      const permittedItem = React.createElement('li', {key: 'other'},
        React.createElement('strong', null, `${translation.permitted_items.other_items}:`),
        React.createElement('p', null, examConfiguration.permittedOtherItems)
      );
      permittedItems.push(permittedItem);
    }

    let itemList = React.createElement('ul', {className: 'data--alt'}, permittedItems);

    if(permittedItems.length > 0) {
      return itemList
    } else {
      return <p><strong>{translation.none}</strong></p>
    }
  }

  getRoster() {
    const { EnrollmentStore } = this.props.store;
    const { courseSid, installSid } = this.props;
    const roles = [
      'instructor'
    ]

    // EnrollmentStore.getCourseData(installSid, courseSid, true)
    EnrollmentStore.getCourseRoster(roles, installSid, courseSid, true);
  }

  getIncidents() {
    this.props.store.ExamStore.getSessionEvents(this.props.installSid, this.props.examSid, this.props.session.sid, true);
  }

  reportIncident(sid) {
    this.props.store.ManagerStore.reportIncident = true;
    this.props.store.ManagerStore.incidentSession = sid;
    this.props.store.ManagerStore.incidentSid = null;

  }

  editIncident(sessionSid, incidentSid) {
    this.props.store.ManagerStore.reportIncident = true;
    this.props.store.ManagerStore.incidentSession = sessionSid;
    this.props.store.ExamStore.incidentSid = incidentSid;
  }

  deleteIncident(incidentSid) {
    const { translation } = this.props;

    const msg = {
      heading: `${translation.delete_incident.heading}?`,
      body: translation.delete_incident.body,
      button: translation.delete_incident.button
    }

    confirm(
      msg,
      () => this.props.store.ExamStore.deleteSessionEvent(
        this.props.installSid,
        this.props.examSid,
        this.props.session.sid,
        incidentSid
      )
    );
  }

  renderCancelButton(session) {
    const { translation } = this.props;

    return (
      <div className="panel__section">
        <button
          className="btn--link negative"
          onClick={() => this.confirmCancel(session.sid)}
        >
          {translation.actions.cancel_button}
        </button>
      </div>
    )
  }

  getExamFile() {
    const { ScheduleStore } = this.props.store;
    const { session, installSid } = this.props;
    const fileName = `${session.enrollment.firstName} ${session.enrollment.lastName} - ${session.exam.title}`;

    ScheduleStore.getExamFile(installSid, session.examConfiguration.sid, session.sid, fileName);
  }

  render() {
    const _this = this;
    const { examSid, installSid, location, session, translation } = this.props;
    const { EnrollmentStore, ExamStore, ManagerStore, ScheduleStore, SessionStore } = this.props.store;
    let address = location ? `${location.address1 || ''} ${location.address2 || ''}` : '';
    let seatName = 'Unassigned';
    let useSeatManagement = false;

    if (ScheduleStore.events[0] &&
      ScheduleStore.events[0].appointment &&
      ScheduleStore.events[0].appointment.seat &&
      ScheduleStore.events[0].appointment.seat.title
      ) {
        seatName = ScheduleStore.events[0].appointment.seat.title;
      }

    if (ScheduleStore.locationCalendar) {
      useSeatManagement = ScheduleStore.locationCalendar.useSeatManagement;
    }

    // Don’t use the default tab styles
    Tabs.setUseDefaultStyles(false);

    // Check if session has started
    const now = moment(this.props.store.SessionStore.currentTime);
    const appointmentDate = moment(ScheduleStore.session.appointmentDate).local();
    const appointmentDiff = moment.duration(appointmentDate.diff(now)).asHours();

    return(
      <li className={`panel--medium session ${this.state.minimize ? 'minimized' : ''}`}>
        <article>
          {this.props.multi &&
            <header className="panel__header session__header">
              <h2 className="panel__title">{session.accessKey}</h2>

              <div className="panel__tools">
                <button
                  className="minimize__btn"
                  onClick={() => {this.minimizeSession(session.accessKey)}}
                >
                  <span className="meta">{translation.minimize}</span>
                </button>

                <button
                  className="minimize__btn minimize__btn--close"
                  onClick={this.closeSession}
                >
                  <span className="meta">{translation.close}</span>
                </button>
              </div>
            </header>
          }

          <div className="session__body">
            {/* Close session button (online exams) */}
            {!this.props.noInteract &&
              ScheduleStore.session.status.toLowerCase() !== 'closed' &&
              ScheduleStore.session.status.toLowerCase() !== 'cancelled' &&
              ScheduleStore.session.exam.type.toLowerCase() !== 'written' &&
              ScheduleStore.session.workflowModule !== 'hybrid-scheduling' &&
              appointmentDiff <= -.25 &&

              <section className="session__section">
                <h4 className="meta">{translation.exam_details.heading}</h4>

                <div className="btn-group">
                  <button
                    className="btn btn--outline"
                    onClick={() => this.confirmComplete(installSid, examSid, session.sid)}
                  >
                    <icons.iconCheck />
                    {translation.actions.button}
                  </button>
                </div>
              </section>
            }

            {/* Download written exam button */}
            {ScheduleStore.session.exam.type.toLowerCase() === 'written' &&
              ScheduleStore.session.examFile &&
              ScheduleStore.session.status.toLowerCase() !== 'closed' &&
              ScheduleStore.session.status.toLowerCase() !== 'cancelled' &&

              <button
                className="btn"
                onClick={() => this.getExamFile()}
              >
                <icons.iconDownload />
                {translation.download_exam.button}
              </button>
            }

            {/* Upload written exam button */}
            {!this.props.noInteract &&
              ScheduleStore.session.exam.type.toLowerCase() === 'written' &&
              appointmentDiff <= -.25 &&

              <section className="session__section">
                <h4 className="meta">{translation.upload_exam.heading}</h4>

                {session.returnedFile && session.returnedFile.file &&
                  <div className="text-block text-block--push">
                    <a
                      className="files__title"
                      target="_blank"
                      href={session.returnedFile.file}
                    >
                      <icons.icon_pdf />
                      {translation.returned_file} (

                      {moment.utc(session.returnedFile.createdDate)
                             .local()
                             .tz(moment.tz.guess())
                             .format('M/D/YYYY [at] h:mma')})
                    </a>

                    {this.state.hideUpload &&
                      <button
                        className="btn--link files__new"
                        onClick={() => this.setState({hideUpload: false})}
                      >
                        {translation.upload_exam.new}
                      </button>
                    }
                  </div>
                }

                {!this.state.hideUpload &&
                  <FileUpload
                    {...this.props}
                    label={translation.upload_exam.label}
                    helper={translation.upload_exam.helper}
                    onDrop={(attachments) => ManagerStore.returnFiles = attachments}
                    files={this.state.returnFiles}
                    single={true}
                    fileType={'application/pdf'}
                    maxSize={10000000}
                  />
                }

                {ManagerStore.returnFiles.length > 0 &&
                  <div className="btn-group file__submit">
                    <button
                      className="btn"
                      onClick={() => {
                        this.setState({hideUpload: true, returnFiles: []});
                        ManagerStore.returnExam(installSid, examSid, session.sid);
                      }}
                    >
                      <icons.iconUpload />
                      {(!session.returnedFile || !session.returnedFile.file) &&
                        translation.upload_exam.button
                      }

                      {session.returnedFile && session.returnedFile.file &&
                        translation.upload_exam.new_button
                      }
                    </button>
                  </div>
                }
              </section>
            }

            <Tabs
              className="panel__tabs"
              onSelect={this.handleTabs}
            >
              <TabList className="tabs-enabled">
                <Tab>{translation.tabs.exam_details}</Tab>
                <Tab>{translation.tabs.location}</Tab>
                <Tab>{translation.tabs.notes}</Tab>
                <Tab onClick={this.getRoster}>{translation.tabs.faculty}</Tab>
                {!this.props.noInteract &&
                  <Tab onClick={this.getIncidents}>{translation.tabs.incidents}</Tab>
                }
              </TabList>

              <TabPanel>
                <h3 className="meta">{translation.exam_details.heading}</h3>

                <section className="session__section">
                  <h4 className="data-heading">{translation.exam_details.heading}</h4>

                  <ul className="data--alt session__data">
                    <li>
                      <strong>{translation.exam_details.date}:</strong>
                      <p>{moment.utc(session.appointmentDate).local().tz(moment.tz.guess()).format('M/D/YYYY [at] h:mma z')}</p>
                    </li>
                    <li>
                      <strong>{translation.exam_details.duration}:</strong>
                      {session.examConfiguration.duration >= 60 &&
                        <p>{toHours(session.examConfiguration.duration, false, false, true)}</p>
                      }

                      {session.examConfiguration.duration < 60 &&
                        <p>{session.examConfiguration.duration} {translation.exam_details.minutes}</p>
                      }
                    </li>
                    <li>
                      <strong>{translation.exam_details.title}:</strong>
                      <p>{session.exam.title}</p>
                    </li>
                    <li>
                      <strong>{translation.exam_details.type}:</strong>
                      <p>{session.exam.type}</p>
                    </li>

                    {session.exam.type.toLowerCase() !== 'written' &&
                      <li>
                        <strong>
                          <label htmlFor="session-url">
                            {translation.exam_details.url}:
                          </label>
                        </strong>

                        <input
                          id="session-url"
                          type="text"
                          defaultValue={session.exam.url}
                          readOnly
                          onFocus={(e) => e.target.setSelectionRange(0, 9999)}
                        />
                      </li>
                    }

                    {session.exam.type.toLowerCase() !== 'written' && session.examConfiguration.password &&
                      <li>
                        <strong>{translation.exam_details.password}:</strong>

                        <Privacy
                          className="faux-input faux-input--enabled"
                          show={translation.reveal_password}
                          hide={translation.hide_password}
                          private={session.examConfiguration.password}
                          {...this.props}
                        />
                      </li>
                    }


                    {session.schedulingModule === 'smarter-scheduling' &&
                    useSeatManagement &&
                      <li>
                        <strong>{translation.exam_details.seat}</strong>
                        <p>{seatName}</p>
                        {!this.props.noInteract &&
                          <button onClick={() => this.changeSeat()} className='btn--link'>{translation.exam_details.move_seat}</button>
                        }
                      </li>
                    }

                    <li>
                      <strong>{translation.exam_details.status}</strong>
                      <p>{ScheduleStore.session.status}</p>
                      {!this.props.noInteract &&
                      ScheduleStore.session.status.toLowerCase() !== 'closed' &&
                      ScheduleStore.session.status.toLowerCase() !== 'cancelled' &&
                      ScheduleStore.session.status.toLowerCase() !== 'processing' &&
                        <button onClick={()=> this.changeStatus()} className='btn--link'>{translation.exam_details.change_status}</button>
                      }
                    </li>
                  </ul>
                  {!this.props.noInteract &&
                    ScheduleStore.session.status.toLowerCase() !== 'closed' &&
                    ScheduleStore.session.status.toLowerCase() !== 'cancelled' &&
                    ScheduleStore.session.status.toLowerCase() !== 'processing' &&
                      this.renderCancelButton(session)
                  }
                </section>

                <section className="session__section">
                  <h4 className="data-heading">{translation.permitted_items.heading}</h4>

                  {this.permittedItems()}
                </section>

                {/* Attachments */}
                {
                  session.examConfiguration.attachments && session.examConfiguration.attachments.length > 0 &&

                  <section className="session__section">
                    <ExamAttachmentsList
                      parent={this}
                      examDashboard={false}
                      {...this.props}
                      exam={session.exam}
                      examConfiguration={session.examConfiguration}
                      sessionManager={true}
                    />
                  </section>
                }
              </TabPanel>

              <TabPanel>
                <h3 className="meta">{translation.location_information.heading}</h3>

                <section className="session__section">
                  <div className="session-detail__location">
                    <ul className="data--alt vcard">
                      <li>
                        <strong>{translation.location_information.address}</strong>
                        <p className="adr">
                          <span className="street-address">{address}</span>
                          <span className="locality">{location.place}</span>
                          <span className="region">{location.region ? `, ${location.region}` : '' }</span>
                          <span className="postal-code"> {location.postalCode}</span>
                          <span className="country">{location.country}</span>
                        </p>
                      </li>
                    </ul>

                    <img
                      className="map--static session-detail__map"
                      width="400" height="250"
                      src={getMapUrl(location.latitude, location.longitude)}
                      alt="A map of the location"
                    />
                  </div>
                </section>
              </TabPanel>

              <TabPanel>
                <h3>{translation.notes.proctor_notes}</h3>

                <p className={session.examConfiguration.proctorNotes ? '' : 'empty'}>
                  {session.examConfiguration.proctorNotes || 'No proctor notes provided.'}
                </p>

                <h3>{translation.notes.student_notes}</h3>

                <p className={session.examConfiguration.studentNotes ? '' : 'empty'}>
                  {session.examConfiguration.studentNotes || 'No student notes provided.'}
                </p>
              </TabPanel>

              <TabPanel>
                <h3 className="meta">{translation.faculty.heading}</h3>

                {EnrollmentStore.courseRoster.length > 0 &&
                  <table>
                    <thead>
                      <tr>
                        <th className="subtitle" scope="col">{translation.faculty.name}</th>
                        <th className="subtitle" scope="col">{translation.faculty.role}</th>
                        <th className="subtitle" scope="col">{translation.faculty.email}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {EnrollmentStore.courseRoster.map(
                        (key, i) =>
                        <tr key={i}>
                          <td>{key.lastName}, {key.firstName}</td>
                          <td className="capitalize">{key.role}</td>
                          <td>{key.email}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                }

                {
                  EnrollmentStore.courseRoster.length === 0 &&
                  SessionStore.backgroundLoadingCalls.indexOf('CourseRoster') < 0 &&
                  <span className="no-results">{translation.faculty.no_results}</span>
                }

                {
                  EnrollmentStore.courseRoster.length === 0 &&
                  SessionStore.backgroundLoadingCalls.indexOf('CourseRoster') >= 0 &&
                  <span className="loader-bar">Loading…</span>
                }
              </TabPanel>

              {!this.props.noInteract &&
                <TabPanel>
                  <h3 className="meta">{translation.incidents.heading}</h3>

                  {ExamStore.sessionEvents.length > 0 &&
                    <table>
                      <thead>
                        <tr>
                          <th className="subtitle" scope="col">{translation.incidents.type}</th>
                          <th className="subtitle" scope="col">{translation.incidents.subject}</th>
                          <th className="subtitle" scope="col">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {ExamStore.sessionEvents.map(
                          (key, i) =>
                          <tr key={i}>
                            <td>{key.eventType.title}</td>
                            <td>{key.subject}</td>
                            <td className="actions">
                              <button
                                className="btn--outline"
                                onClick={() => {this.editIncident(session.sid, key.sid)}}
                              >
                                <icons.iconEdit />
                                {translation.incidents.edit}
                              </button>

                              <button
                                className="btn--outline btn--negative"
                                onClick={() => {this.deleteIncident(key.sid)}}
                              >
                                <icons.iconTrash />
                                {translation.incidents.delete}
                              </button>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  }

                  {
                    ExamStore.sessionEvents.length === 0 &&
                    SessionStore.backgroundLoadingCalls.indexOf('GetSessionEvents') < 0 &&
                    <span className="no-results">{translation.incidents.no_results}</span>
                  }

                  {
                    ExamStore.sessionEvents.length === 0 &&
                    SessionStore.backgroundLoadingCalls.indexOf('GetSessionEvents') >= 0 &&
                    <span className="loader-bar">Loading…</span>
                  }

                  {SessionStore.backgroundLoadingCalls.indexOf('GetSessionEvents') < 0 &&
                    <button
                      className="btn btn--negative"
                      onClick={() => this.reportIncident(session.sid)}
                    >
                      {translation.incidents.report_incident}
                    </button>
                  }
                </TabPanel>
              }
            </Tabs>

          </div>
        </article>
      </li>
    )
  }
})

export default translate('SessionInformation')(SessionInformation);



// WEBPACK FOOTER //
// ./src/app/components/Sessions/Session.js